module.exports = __webpack_public_path__ + "980096519212d90a9a63b0ff9df62f08.png";